import { Modal } from '@consta/uikit/Modal';
import { Header } from '@components/ui/layout/modal/components';
import { useModalQueue } from '@src/hooks';
import { useEffect, useState, useMemo } from 'react';
import { TBaseObjectDto } from '@src/types';
import { useSelector, useDispatch } from 'react-redux';
import { getItems } from '@features/enums/enum-actions';
import { getEnums } from '@features/enums/enum-slice';
import { AppDispatch } from '@store/index';
import cn from 'classnames';
import { StateBadge } from '@components/ui/indicators/state-badge';

export const HeaderState = ({ setIsShow, className, container, title = 'Выбор статуса', value, onChange }: any) => {
    const dispatch = useDispatch<AppDispatch>();
    const enumItems: any = useSelector(getEnums);
    const items: any = useMemo(() => {
        const currentEnum = enumItems.find((enumItem: any) => enumItem.type === value?.$type);

        if (currentEnum) {
            return [...currentEnum.items];
        }

        return [];
    }, [enumItems]);

    const closeModalHandler = useModalQueue(setIsShow);
    const [modalContainer, setModalContainer] = useState<HTMLDivElement | undefined>(container);

    useEffect(() => {
        setModalContainer(container || (document.getElementById('MainLayout') as HTMLDivElement));

        if (value?.$type && !enumItems?.find((enumItem: any) => enumItem.type === value.$type)) {
            dispatch(getItems({ type: value.$type }));
        }
    }, []);

    return (
        <Modal
            isOpen={true}
            hasOverlay={true}
            onClickOutside={(e: any) => {
                if (!e.target.closest('.dhx_popup')) {
                    closeModalHandler();
                }
            }}
            position="center"
            onEsc={closeModalHandler}
            className={cn(className, 'w-[20.0064vmin] min-h-[4.0635vmin]')}
            container={modalContainer}
        >
            <div className="header-state-modal flex flex-col h-full p-[2.1171vmin] ">
                <Header title={title} />

                <div className="flex flex-col gap-[0.6351vmin]">
                    {items.map((item: TBaseObjectDto, key: number) => (
                        <StateBadge
                            key={key}
                            state={item}
                            onClick={() => {
                                onChange(item);
                                closeModalHandler();
                            }}
                        />
                    ))}
                </div>
            </div>
        </Modal>
    );
};
